import { type ComponentPropsWithoutRef, memo } from 'react';

import { TriangleDown } from '@air/next-icons';
import { Button, type ButtonProps } from '@air/primitive-button';
import { cn } from '@air/utils-tailwind';

export type GallerySectionHeaderProps = ComponentPropsWithoutRef<'div'> & {
  collapsed?: boolean;
  onToggleCollapse?: ButtonProps['onClick'];
};

export const GallerySectionHeader = memo(
  ({ children, className, collapsed, onToggleCollapse, ...restOfProps }: GallerySectionHeaderProps) => {
    return (
      <div className={cn('group/gallery-section-header', className)} data-collapsed={collapsed} {...restOfProps}>
        <Button
          data-testid="GALLERY_SECTION_HEADER_TOGGLE_BUTTON"
          appearance="ghost"
          color="grey"
          onClick={onToggleCollapse}
          size="small"
          suffix={
            <TriangleDown className="size-3 transition-transform group-data-[collapsed=true]/gallery-section-header:-rotate-90" />
          }
        >
          <span className="font-bold uppercase tracking-wider">{children}</span>
        </Button>
      </div>
    );
  },
);

GallerySectionHeader.displayName = 'GallerySectionHeader';
